import { FC } from "react";

export const MAX_HEIGHT_LISTS_DASHBOARD = 456;

export enum TypeDashboardComponents{
    LIST = 1,
    CARD = 2,
    CHART = 3,
    PIE = 4,
    GAUGE = 5,
    RADAR = 6,

    LIST_2 = 7,
    CARD_2 = 8,
    CHART_2 = 9,
    PIE_2 = 10,
    GAUGE_2 = 11,
    RADAR_2 = 12,

    LIST_3 = 13,
    CARD_3 = 14,
    CHART_3 = 15,
    PIE_3 = 16,
    GAUGE_3 = 17,
    RADAR_3 = 18, 
    
    LIST_4 = 19,
    CARD_4 = 20,
    CHART_4 = 21,
    PIE_4 = 22,
    GAUGE_4 = 23,
    RADAR_4 = 24,

    LIST_5 = 25,
    CARD_5 = 26,
    CHART_5 = 27,
    PIE_5 = 28,
    GAUGE_5 = 29,
    RADAR_5 = 30,

    LIST_6 = 31,
    CARD_6 = 32,
    CHART_6 = 33,
    PIE_6 = 34,
    GAUGE_6 = 35,
    RADAR_6 = 36,

    LIST_7 = 37,
    CARD_7 = 38,
    CHART_7 = 39,
    PIE_7 = 40,
    GAUGE_7 = 41,
    RADAR_7 = 42,

    LIST_8 = 43,
    CARD_8 = 44,
    CHART_8 = 45,
    PIE_8 = 46,
    GAUGE_8 = 47,
    RADAR_8 = 48
}

export enum FormatDashboard{
    ACTIONS = 1,
    BUSINESS_DIAGNOSIS = 2,
    INDICATORS = 4,
    STRATEGIC_PLANNING = 5,
    ANALYSIS = 6,
    PROJECT = 7,
    OCCURRENCES = 8,
    AUDITS = 9,
    MEETINGS = 10,
    RISKS = 12,
}

export interface ICardConfigs{
    card?: ICardsDashboardData;
}

export interface IActionsDashboardComponents{
    type: TypeDashboardComponents;
}

export interface ICardsDashboardData{
    daa002Id: number;
    daa002Tipo: number;
    daa002Titulo: string;
    daa002Descricao: string;
    daa002Formato: number | null;
    daa002Idorigem: number | null;
    daa002Cor: string | null;
    daa002Coluna: number;
}

export interface IEditableCards{
    daa002Titulo?: string;
    daa002Descricao?: string;
    daa002Idorigem?: number | null;
    daa002Cor?: string | null;
}

export interface ILinesDashboardData{
    daa003Id: number;
    daa003Nrocolunas: number;
    daa003Ordem: number;
    cards: ICardsDashboardData[];
}

export interface IDashboardData{
   daa001Id: number;
   daa001Titulo: string;
   daa001Descricao: string | null;
   lines: ILinesDashboardData[];
}

export interface IDashboardTemplate{
    format: FormatDashboard;
    title: string;
    description: string;
    id: string;
    type: TypeDashboardComponents;
    src: any;
    component: FC<ICardConfigs>;
}
